module.exports = __webpack_public_path__ + "static/media/view9-ex1-slow.4af534d2.mp3";